const getHtmlLangValue = require("./getHtmlLangValue");
const convertHtmlLangToLocale = require("./convertHtmlLangToLocale");

/**
 * @return {string}
 */
module.exports = function getPageLocale() {
    const lang = getHtmlLangValue();
    return convertHtmlLangToLocale(lang);
}